import { ExcellentQuality } from './ExcellentQuality/ExcellentQuality';
import { PoorQuality } from './PoorQuality/PoorQuality';
import { getQualityScore, LivekitGetQualityScore } from './getQualityScore/getQualityScore';
import { useAppStateContext } from '../../AppStateProvider/AppStateProvider';
import { QualityModal } from './QualityModal/QualityModal';
import { useState } from 'react';
import { TWILIO } from '../../../constants';

export enum QualityScore {
  Poor,
  Suboptimal,
  Good,
  Excellent,
}

export function Quality() {
  const { state } = useAppStateContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isTwilio = state.selectedProvider === TWILIO;

  const { totalQualityScore, qualityReport } = isTwilio
    ? getQualityScore(state.preflightTest.report, state.bitrateTest.report)
    : LivekitGetQualityScore(state.livekitQualityStatus);

  return (
    <>
      <QualityModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} report={qualityReport} />
      {totalQualityScore === QualityScore.Good || totalQualityScore === QualityScore.Excellent ? (
        <ExcellentQuality quality={totalQualityScore} openModal={() => setIsModalOpen(true)} />
      ) : (
        <PoorQuality quality={totalQualityScore} openModal={() => setIsModalOpen(true)} />
      )}
    </>
  );
}
